<template>
  <div>
    <p class="check-title">{{ label }}</p>
    <div v-for="(option, index) in options" :key="option" @click="checkedToggle(option)">
      <div class="check" v-if="isShow || (showCount && (index < showCount))">
        <label :class="`checkbox ${value?.includes(option) ? 'selected' : ''}`">
          <svg
            v-if="value?.includes(option)" width="8" height="6" viewBox="0 0 8 6"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 3L3 5L7 1" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </label>
        <p>{{ option }}</p>
      </div>
    </div>
    <div @click="isShow = !isShow" class="see_more">
      <p>{{isShow ? 'See Less' : 'See More'}}</p>
      <svg v-if="!isShow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" width="20" height="20">
        <path fill="#09373D" d="M10,12.4c-0.2,0-0.4-0.1-0.5-0.2L6.1,8.9c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l2.8,2.8l2.8-2.8 c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-3.3,3.3C10.4,12.3,10.2,12.4,10,12.4z"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" width="20" height="20">
        <path fill="#09373D" d="M10,7.6c0.2,0,0.4,0.1,0.5,0.2l3.4,3.3c0.3,0.3,0.3,0.8,0,1.1c-0.3,0.3-0.8,0.3-1.1,0L10,9.4l-2.8,2.8 c-0.3,0.3-0.8,0.3-1.1,0s-0.3-0.8,0-1.1l3.3-3.3C9.6,7.7,9.8,7.6,10,7.6z"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Multiselect',
  props: ['value', 'label', 'options', 'showCount'],
  data: () => ({
    isShow: false,
  }),
  methods: {
    checkedToggle (val) {
      let index = this.value.indexOf(val)
      if (index !== -1) {
        this.value.splice(index, 1)
      } else this.value.push(val)
      this.$emit('input', this.value)
      this.$emit('change', this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.check-title {
  color: var(--Basic-Black) !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 20px;
  margin-bottom: 16px !important;
}
.see_more {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 32px;
  p {
    margin: 0;
    color: var(--Primary-Shades-Primary);
    font-family: "DM Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
</style>
